import { MsCopy as g, MsWhatsapp as s, MsFacebook as c, MsEnvelope as u } from "@sunrise/icons";
import { useToastManager as k } from "@sunrise/shared";
import { trackWithBaseTracking as C, NOT_SET as S } from "@sunrise/tracking";
import { Components as a } from "@sunrise/types";
import { defineComponent as b, toRef as i, computed as y, watch as v } from "vue";
import M from "./index40.js";
import x from "./index34.js";
import w from "./index49.js";
import { useLinkBuilder as _ } from "./index528.js";
const A = {
  mslayer_element_text: "teilen",
  mslayer_element_type_text: S
}, N = b({
  name: "CsShareModal",
  components: {
    MsEnvelope: u,
    MsFacebook: c,
    MsWhatsapp: s,
    CsToast: w,
    MsCopy: g,
    CsModal: x,
    CsSecondaryButton: M
  },
  model: {
    prop: "isVisible",
    event: "update:isVisible"
  },
  props: {
    isVisible: {
      type: Boolean,
      required: !0
    },
    url: String,
    title: {
      type: String,
      required: !0
    },
    description: String,
    shareTrackingData: Object,
    openTrackingData: Object,
    ecIdTrackingStrings: Object
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const { toasts: n, addToast: d, removeToast: p } = k(), { computedLinks: r } = _(
      i(() => e.url),
      i(() => e.title),
      i(() => e.description),
      i(() => e.ecIdTrackingStrings)
    ), m = y(() => [
      {
        title: "Facebook",
        icon: c,
        bgColor: "#1877f2",
        color: "text-color-neutral-white hover:text-color-neutral-white visited:text-color-neutral-white",
        url: r.value.Facebook,
        trackingType: a.CsShareModal.ShareTypes.FACEBOOK
      },
      {
        title: "WhatsApp",
        icon: s,
        bgColor: "#60d66a",
        color: "text-color-neutral-white hover:text-color-neutral-white visited:text-color-neutral-white",
        url: r.value.Whatsapp,
        trackingType: a.CsShareModal.ShareTypes.WHATSAPP
      },
      {
        title: "Email",
        icon: u,
        bgColor: "#ffda00",
        color: "text-color-neutral-black hover:text-color-neutral-black visited:text-color-neutral-black",
        url: r.value.Email,
        trackingType: a.CsShareModal.ShareTypes.EMAIL
      }
    ]);
    v(
      () => e.isVisible,
      (o) => {
        o && (navigator.share && (navigator.share({
          url: r.value.native,
          text: e.description,
          title: e.title
        }), t("update:isVisible", !1)), V(e.openTrackingData));
      }
    );
    function h(o) {
      t("update:isVisible", o);
    }
    function T(o) {
      p(o);
    }
    async function f() {
      try {
        await window.navigator.clipboard.writeText(r.value.Copy), d(), l(a.CsShareModal.ShareTypes.COPY, e.shareTrackingData);
      } catch {
      }
    }
    return {
      onUpdate: h,
      copyToClipBoard: f,
      computedButtons: m,
      toasts: n,
      onClose: T,
      trackClick: l,
      computedLinks: r
    };
  }
});
function l(e, t) {
  if (!t)
    return;
  const n = E(t, e);
  C(n);
}
function E(e, t) {
  return Object.assign(
    {},
    A,
    {
      mslayer_element_variant: O(t)
    },
    e
  );
}
function O(e) {
  switch (e) {
    case a.CsShareModal.ShareTypes.COPY:
      return "link_kopieren";
    case a.CsShareModal.ShareTypes.EMAIL:
      return "Mail";
    default:
      return e;
  }
}
function V(e) {
  const t = navigator.share ? a.CsShareModal.ShareTypes.NATIVE : "modal";
  l(t, e);
}
export {
  N as default
};
